import React from 'react';
import { Icon } from '../Icon/Icon';
import './ThemeSelector.css';

export const ThemeSelector = ({
  value = 'system',
  onChange,
  className = '',
  ...props
}) => {
  const handleChange = (newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  };

  const baseClass = 'theme-selector';
  const combinedClassName = [baseClass, className].filter(Boolean).join(' ');

  return (
    <div className={combinedClassName} {...props}>
      <button
        type="button"
        className={`theme-selector__button tooltip ${value === 'system' ? 'theme-selector__button--active' : ''}`}
        onClick={() => handleChange('system')}
        aria-label="System theme"
        aria-pressed={value === 'system'}
        data-tooltip="System theme"
      >
        <Icon 
          name={value === 'system' ? 'system-mode-active' : 'system-mode'} 
          size="medium" 
        />
      </button>
      <button
        type="button"
        className={`theme-selector__button tooltip ${value === 'light' ? 'theme-selector__button--active' : ''}`}
        onClick={() => handleChange('light')}
        aria-label="Light theme"
        aria-pressed={value === 'light'}
        data-tooltip="Light theme"
      >
        <Icon 
          name={value === 'light' ? 'light-mode-active' : 'light-mode'} 
          size="medium" 
        />
      </button>
      <button
        type="button"
        className={`theme-selector__button tooltip ${value === 'dark' ? 'theme-selector__button--active' : ''}`}
        onClick={() => handleChange('dark')}
        aria-label="Dark theme"
        aria-pressed={value === 'dark'}
        data-tooltip="Dark theme"
      >
        <Icon 
          name={value === 'dark' ? 'dark-mode-active' : 'dark-mode'} 
          size="medium" 
        />
      </button>
    </div>
  );
};

